export enum IconSize {
  SmallX = 'small-x',
  Small = 'small',
  Default = 'default',
  Large = 'large',
  LargeX = 'large-x',
  LargeXX = 'large-xx',
}
